export default __webpack_public_path__ + "static/media/banner-right-img.8952cdab.png";